import Input from './Input';

const InputWithLabel = ({label, ...props}) => {
    return (
      <div>
        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
          {label}
        </label>
       <Input {...props}/>
      </div>
    )
  }

  export default InputWithLabel;